@if (!isReport) {
  <i class="ml-3 mt-2 far fa-chart-bar cursor-pointer text-primary font-size-medium chart-y-axis-button"
    [matTooltip]="'DATA_STUDIO.DATA_ANALYSIS.CHART_AXIS_CONFIG' | translate" [matTooltipPosition]="'right'"
    [ngClass]="{'chart-axis-active': customAxisActive}"
    (click)="openYAxisConfiguration()">
  </i>
}
<highcharts-chart
  class="w-100 d-block"
  [Highcharts]="highcharts"
  [callbackFunction]="chartCallback"
  [(update)]="update"
  [options]="chartOptions">
</highcharts-chart>
